const brlFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL'
});

function toNumber(value: string | number): number {
  return typeof value === 'string' ? Number(value) : value;
}

export function formatBRL(value: string | number): string {
  return brlFormatter.format(toNumber(value));
}

export function formatKwh(value: string | number): string {
  return `${toNumber(value).toFixed(2).replace('.', ',')} kWh`;
}

export function formatKw(value: string | number): string {
  return `${toNumber(value).toFixed(1).replace('.', ',')} kW`;
}
